var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" "+_vm._s(_vm.title)+" "),_c('i',{staticClass:"fas fa-question-circle labeled-tooltip",attrs:{"id":_vm.id}}),_c('b-tooltip',{attrs:{"target":_vm.id,"placement":"left"}},[_vm._v(" "+_vm._s(_vm.description)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }